import { ConfirmModal, InputModal, Modal } from '../../../../components/Modal'

export function StoryEditorModals(props) {
  const { tx, showNewStoryModal, setShowNewStoryModal, createNewStory,
    showDeleteStoryModal, setShowDeleteStoryModal, handleDeleteStory, story,
    currentId, showDeleteSegmentModal, setShowDeleteSegmentModal, removeSegment,
    showTemplateModal, setShowTemplateModal, selectedTemplateId,
    setSelectedTemplateId, doImportTemplate, importingTemplate, safeStoryId,
    importStoryId, loadingTemplates, setImportStoryId, importTitle,
    setImportTitle, templates, startImportTemplate } = props
  return (
    <>
      <InputModal
        open={showNewStoryModal}
        onClose={() => setShowNewStoryModal(false)}
        onSubmit={createNewStory}
        title={tx({ zh: '创建新故事', en: 'Create new story' })}
        label={tx({ zh: '故事 ID（字母数字、下划线）', en: 'Story ID (letters/numbers/underscore)' })}
        placeholder="my_story"
      />

      <ConfirmModal
        open={showDeleteStoryModal}
        onClose={() => setShowDeleteStoryModal(false)}
        onConfirm={handleDeleteStory}
        title={tx({ zh: '删除故事', en: 'Delete story' })}
        message={tx(
          { zh: '确定要删除故事「{name}」吗？此操作不可撤销。', en: 'Delete story “{name}”? This cannot be undone.' },
          { name: story?.title || currentId }
        )}
        confirmText={tx({ zh: '删除', en: 'Delete' })}
        danger
      />

      <ConfirmModal
        open={showDeleteSegmentModal !== null}
        onClose={() => setShowDeleteSegmentModal(null)}
        onConfirm={() => {
          if (showDeleteSegmentModal !== null) removeSegment(showDeleteSegmentModal)
        }}
        title={tx({ zh: '删除段落', en: 'Delete segment' })}
        message={tx(
          { zh: '确定要删除段落 {n} 吗？', en: 'Delete segment {n}?' },
          { n: (showDeleteSegmentModal ?? 0) + 1 }
        )}
        confirmText={tx({ zh: '删除', en: 'Delete' })}
        danger
      />

      <Modal
        open={showTemplateModal}
        onClose={() => setShowTemplateModal(false)}
        title={tx({ zh: '导入范例（story-template）', en: 'Import sample (story-template)' })}
        footer={
          selectedTemplateId ? (
            <>
              <button
                onClick={() => setSelectedTemplateId('')}
                className="px-4 py-2 rounded-2xl bg-white hover:bg-slate-50 text-slate-700 text-sm font-bold transition-colors border-2 border-slate-100"
              >
                {tx({ zh: '返回', en: 'Back' })}
              </button>
              <button
                onClick={doImportTemplate}
                disabled={importingTemplate || !safeStoryId(importStoryId)}
                className="px-4 py-2 rounded-2xl bg-emerald-600 hover:bg-emerald-700 disabled:bg-slate-200 disabled:text-slate-400 text-white text-sm font-extrabold transition-colors border-2 border-emerald-600 disabled:border-slate-200"
              >
                {importingTemplate ? tx({ zh: '导入中...', en: 'Importing…' }) : tx({ zh: '导入', en: 'Import' })}
              </button>
            </>
          ) : (
            <button
              onClick={() => setShowTemplateModal(false)}
              className="px-4 py-2 rounded-2xl bg-white hover:bg-slate-50 text-slate-700 text-sm font-bold transition-colors border-2 border-slate-100"
            >
              {tx({ zh: '关闭', en: 'Close' })}
            </button>
          )
        }
      >
        {loadingTemplates ? (
          <div className="text-sm text-slate-500 font-medium">{tx({ zh: '加载中...', en: 'Loading…' })}</div>
        ) : selectedTemplateId ? (
          <div className="space-y-3">
            <div className="text-sm text-slate-700 font-bold">
              {tx({ zh: '模板：', en: 'Template: ' })}
              {selectedTemplateId}
            </div>
            <div>
              <div className="text-xs text-slate-500 mb-1 font-bold">{tx({ zh: '导入为 story_id', en: 'Import as story_id' })}</div>
              <input
                value={importStoryId}
                onChange={(e) => setImportStoryId(e.target.value)}
                className="w-full bg-white border-2 border-slate-100 rounded-2xl px-3 py-2 text-slate-800 text-sm font-mono outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-100"
                placeholder="my_story_demo"
              />
              <div className="text-[10px] text-slate-400 mt-1 font-medium">
                {tx({
                  zh: '只支持字母数字下划线；若已存在会提示冲突。',
                  en: 'Only letters/numbers/underscore. If it exists, you will see a conflict message.',
                })}
              </div>
            </div>
            <div>
              <div className="text-xs text-slate-500 mb-1 font-bold">{tx({ zh: '标题（可改）', en: 'Title (editable)' })}</div>
              <input
                value={importTitle}
                onChange={(e) => setImportTitle(e.target.value)}
                className="w-full bg-white border-2 border-slate-100 rounded-2xl px-3 py-2 text-slate-800 text-sm outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-100"
                placeholder={tx({ zh: '故事标题', en: 'Story title' })}
              />
            </div>
          </div>
        ) : (
          <div className="space-y-2">
            <div className="text-sm text-slate-700 font-extrabold">{tx({ zh: '选择一个模板：', en: 'Choose a template:' })}</div>
            <div className="space-y-2">
              {(templates || []).map((t) => (
                <button
                  key={t.id}
                  type="button"
                  onClick={() => startImportTemplate(t)}
                  className="w-full text-left p-3 rounded-2xl border-2 border-slate-100 bg-white hover:bg-slate-50 transition-colors"
                >
                  <div className="text-slate-900 font-extrabold">{t.name}</div>
                  <div className="text-xs text-slate-500 mt-1 font-medium">
                    {tx({ zh: '{n} 张图', en: '{n} images' }, { n: t.image_count })}
                    {t.has_audio ? tx({ zh: ' · 含音频', en: ' · with audio' }) : tx({ zh: ' · 无音频', en: ' · no audio' })}
                  </div>
                </button>
              ))}
              {(templates || []).length === 0 && (
                <div className="text-xs text-slate-500 font-medium">
                  {tx({ zh: '没有找到模板目录：`/app/story-template/*`', en: 'Template directory not found: `/app/story-template/*`' })}
                </div>
              )}
            </div>
          </div>
        )}
      </Modal>

    </>
  )
}
